import { useQuery } from '@tanstack/react-query';
import { useApi } from 'services/api';
import type { components } from 'types/schemas/api-schema';

export type Tenant = components['schemas']['Tenant'];
export type TenantPayload = components['schemas']['TenantAttributes'];
type PagedTenants = components['schemas']['PagedTenants'];

export const TENANTS_QUERY_KEY = ['tenants'] as const;

export const useTenants = () => {
  const api = useApi();

  return useQuery<Tenant[]>({
    queryKey: TENANTS_QUERY_KEY,
    queryFn: async () => {
      const response = (await api.get('/tenants', {})) as unknown as PagedTenants;
      return response.items ?? [];
    },
  });
};
